// Soko & Co – collection carousel
// Replaces [collection-carousel="handle"] with a Swiper slider of that collection.
// Uses the SECOND product image when available; falls back to the first.
(function () {
  // Common blog body selectors (first match wins)
  const CONTAINER_SELECTOR =
    '.article__content-inner, .article-template__content.rte, .article .rte, .article-content, .rte';

  document.addEventListener('DOMContentLoaded', initSokoCarousel);

  function initSokoCarousel() {
    const container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return;

    // 1) Replace shortcode(s) with a Swiper wrapper
    let idx = 0;
    container.innerHTML = container.innerHTML.replace(
      /\[collection-carousel="([^"]+)"\]/g,
      (_, handle) => {
        const id = `soko-carousel-${handle}-${idx++}`;
        return `
          <section id="${id}" class="soko-slider-wrapper soko-slider" data-handle="${handle}">
            <div class="swiper-container">
              <div class="swiper-wrapper"></div>
            </div>
          </section>`;
      }
    );

    // 2) Build each carousel
    container.querySelectorAll('.soko-slider-wrapper').forEach(buildCarousel);
  }

  function buildCarousel(wrapper) {
    const handle   = wrapper.dataset.handle;
    const trackEl  = wrapper.querySelector('.swiper-wrapper');
    const swiperEl = wrapper.querySelector('.swiper-container');

    fetch(`/collections/${handle}/products.json?limit=10`)
      .then(r => r.json())
      .then(json => {
        (json.products || []).forEach(product => {
          // use second image if present, else first, else empty
          const imgSrc = product.images?.[1]?.src || product.images?.[0]?.src || '';
          const variant = product.variants?.[0];
          if (!variant) return;

          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          if (imgSrc) slide.style.backgroundImage = `url(${imgSrc})`;

          const priceDollars =
            typeof variant.price === 'number'
              ? (variant.price / 100).toFixed(2)
              : String(variant.price || '0.00');

          slide.innerHTML = `
            <div class="product-name">${product.title}</div>
            <div class="product-price">$${priceDollars}</div>
            <form class="purchase-form" action="/cart/add" method="post">
              <input type="hidden" name="id" value="${variant.id}">
              <button type="submit" aria-label="Add ${escapeHtml(product.title)} to cart">Add To Cart</button>
            </form>
          `;

          trackEl.appendChild(slide);
        });

        // 3) Initialize Swiper after slides exist
        new Swiper(swiperEl, {
          freeMode: true,
          slidesPerView: 'auto',
          spaceBetween: 12,
          loop: false,
          navigation: false,
          pagination: false
        });
      })
      .catch(err => console.error('Soko & Co carousel error:', err));
  }

  // simple HTML escaper for button aria-label
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
})();
